import React from "react";
import { Select, MenuItem, FormControl, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: 200,
  "& .MuiSelect-select": {
    paddingTop: 8,
    paddingBottom: 8,
  },
}));

const SortDropdown = ({ value, onChange }) => {
  const { t } = useTranslation();
  
  const options = [
    { value: "-publication_date", label: t("books.sort.sortOptions.newestArrivals") },
    { value: "publication_date", label: t("books.sort.sortOptions.oldestFirst") },
    { value: "-price", label: t("books.sort.sortOptions.priceHighToLow") },
    { value: "price", label: t("books.sort.sortOptions.priceLowToHigh") },
    { value: "title", label: t("books.sort.sortOptions.titleAToZ") },
    { value: "-title", label: t("books.sort.sortOptions.titleZToA") },
  ];

  return (
    <StyledFormControl size="small">
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        defaultValue="-publication_date"
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};

export default SortDropdown;
